import { CheckName } from 'dashboard/models/check/check';
import { VerificationCheckConfig } from 'dashboard/models/verification-check-config/verification-check-config';

export enum MrzDetectionRequirement {
  Complete = 'complete',
  Detected = 'detected',
}

export type MrzDetectionCheckName = CheckName.IdMrzDetection;

export interface MrzDetectionCheckConfig extends VerificationCheckConfig {
  check: MrzDetectionCheckName;
  'detection-requirement': MrzDetectionRequirement;
}

export function isMrzDetectionCheck(
  verificationCheck: VerificationCheckConfig,
): verificationCheck is MrzDetectionCheckConfig {
  switch (verificationCheck.check) {
    case CheckName.IdMrzDetection:
      return true;
    default:
      return false;
  }
}
